import { useEffect } from "react"
import { IData } from "../../../../api/modelAPI/detectedSensitiveWordLog"

type Props = {
    item: IData
}

const View = ({ item }: Props) => {
 

    return (
        <div className="d-flex justify-content-start align-items-center view-description">
            <textarea value={item.description} disabled={true} />
        </div>

    )
}
export default View